import type { Command } from '../types/command';

/**
 * True when any registered command has `status === 'pending'`. The
 * search field reads this through `useCommandRegistry()` to decide
 * whether to render its loading indicator.
 *
 * Aggregation is a single O(N) walk of the registry. N is small
 * (the entire flat command set, including async children, typically
 * ≤ a few dozen items), so the cost is negligible and there's no
 * benefit to caching beyond what React already does at the call
 * site.
 *
 * Only actions can have a status -- links are resolved by
 * construction. The discriminant check below lets us narrow without
 * touching link rows.
 */
export function hasAnyPendingCommand(commands: Record<string, Command>): boolean {
  for (const command of Object.values(commands)) {
    if (command.type === 'action' && command.status === 'pending') {
      return true;
    }
  }
  return false;
}
